import { memo } from "react";
import ReactECharts from "echarts-for-react";

function CagrGroupedBar({ periods, series, height = "260px" }) {
  const allVals = series.flatMap(s => s.values).filter(v => v != null);
  if (allVals.length === 0) {
    return (
      <p className="text-xs text-gray-500 py-4 text-center">No CAGR data available</p>
    );
  }

  const minV = Math.min(0, ...allVals);
  const maxV = Math.max(0, ...allVals);
  const pad = Math.max((maxV - minV) * 0.2, 4);

  const option = {
    backgroundColor: 'transparent',
    animation: true,
    grid: { top: 36, right: 12, bottom: 28, left: 36, containLabel: false },
    legend: {
      top: 4,
      left: 'center',
      textStyle: { color: '#d1d5db', fontSize: 10 },
      itemWidth: 14, itemHeight: 8,
    },
    xAxis: {
      type: 'category',
      data: periods,
      axisLabel: { color: '#9ca3af', fontSize: 11, fontWeight: '600' },
      axisLine: { lineStyle: { color: '#374151' } },
      axisTick: { show: false },
    },
    yAxis: {
      type: 'value',
      min: minV < 0 ? minV - pad : 0,
      max: maxV + pad,
      axisLabel: { color: '#9ca3af', fontSize: 10, formatter: v => `${Math.round(v)}%` },
      splitLine: { lineStyle: { color: '#1f2937', type: 'dashed' } },
      axisLine: { show: false },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      backgroundColor: '#111827',
      borderColor: '#374151',
      textStyle: { color: '#e5e7eb', fontSize: 11 },
      formatter: params => {
        const period = periods[params[0]?.dataIndex] || '';
        return `<b>${period}</b><br/>` + params
          .filter(p => p.value != null)
          .map(p => `<span style="color:${p.color}">●</span> ${p.seriesName}: <b>${Number(p.value).toFixed(2)}%</b>`)
          .join('<br/>');
      },
    },
    series: series.map(s => ({
      name: s.name,
      type: 'bar',
      data: s.values.map(v => (v == null ? '-' : v)),
      itemStyle: { color: s.color, borderRadius: [3, 3, 0, 0] },
      barGap: '15%',
      barCategoryGap: '35%',
      label: {
        show: true,
        position: 'top',
        color: '#d1d5db',
        fontSize: 9,
        fontWeight: 'bold',
        formatter: p => (p.value === '-' || p.value == null) ? '' : `${Math.round(Number(p.value))}%`,
      },
    })),
  };

  return <ReactECharts option={option} style={{ height, width: '100%' }} />;
}

export default memo(CagrGroupedBar);
